import React from "react"


import AppBar from "@material-ui/core/AppBar"

import Toolbar from "@material-ui/core/Toolbar"

import { ToolbarLeft } from "./modal-screen"
import {
  CentralToolbarSection,

} from "./nav-header"
import { ModalScreenLayoutProps, useClose } from "./ModalScreenLayout"
import { ReactFC } from "types"
import styled from "styled-components"


export const ModalContentContainer = styled.div`
  position: absolute;
  top: 70px;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
`

export const ScreenLayoutWrapper = styled.div`
  max-width: 100vw;
  position: relative;
`

export const NoBottomNavScreenLayout: ReactFC<ModalScreenLayoutProps> = (props) => {
  const close = useClose({
    onBeforeClose: props.onBeforeClose,
    route: props.back,
  })

  const { className, right, children, left } = props

  return (
    <ScreenLayoutWrapper className={className}>
      <AppBar elevation={0} position="fixed">
        <Toolbar>
          <div>
            <ToolbarLeft close={close} {...props}>
              {left}
            </ToolbarLeft>
          </div>
          <CentralToolbarSection>
            {props.center}
          </CentralToolbarSection>
          <div>{right}</div>
        </Toolbar>
      </AppBar>
      <ModalContentContainer>
        {children}
      </ModalContentContainer>
    </ScreenLayoutWrapper>
  )
}

export default NoBottomNavScreenLayout

